import { Controller } from "@hotwired/stimulus"

const CLOSE_DELAY_MS = 150

export default class extends Controller {
  static targets = ["trigger", "popover"]

  disconnect() {
    this.cancelClose()
  }

  open() {
    this.cancelClose()
    this.position()
    this.popoverTarget.classList.remove("hidden")
  }

  // Defer the hide so the user can move the cursor from the trigger to the
  // popover (or back) without it disappearing mid-flight. `open()` cancels
  // the pending close, so hover-into-popover keeps it visible.
  close() {
    this.cancelClose()
    this.closeTimeout = window.setTimeout(() => {
      this.popoverTarget.classList.add("hidden")
      this.closeTimeout = null
    }, CLOSE_DELAY_MS)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    if (this.popoverTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.cancelClose()
      this.popoverTarget.classList.add("hidden")
    }
  }

  cancelClose() {
    if (this.closeTimeout) {
      window.clearTimeout(this.closeTimeout)
      this.closeTimeout = null
    }
  }

  // Position the popover in viewport coords just below the trigger.
  // `position: fixed` lets us escape any overflow:auto/hidden ancestor
  // (e.g. the track-select listbox) without layout side effects.
  position() {
    const rect = this.triggerTarget.getBoundingClientRect()
    const popoverWidth = this.popoverTarget.offsetWidth || 224 // w-56 = 14rem ≈ 224px
    const margin = 8
    const left = Math.min(rect.left, window.innerWidth - popoverWidth - margin)
    this.popoverTarget.style.top = `${rect.bottom + 4}px`
    this.popoverTarget.style.left = `${Math.max(margin, left)}px`
  }
}
